import React from "react";
import { Flex, Text, TextProps } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { inLabel as defaultInLabel, truncatedWrapper } from "./styles_vanilla.css";

export type PositionNameProps = {
  account?: string | null;
  entity?: string | null;
  nameVariant?: TextProps["variant"];
  inVariant?: TextProps["variant"];
  className?: string;
  inClassName?: string;
  fallback?: string;
  truncate?: boolean;
};

export const PositionName: React.FC<PositionNameProps> = ({
  account,
  entity,
  nameVariant = "regular-md",
  inVariant = "regular-md",
  className,
  inClassName = defaultInLabel,
  fallback = "--",
  truncate = false,
}) => {
  const accountText = account ?? fallback;
  const entityText = entity ?? fallback;

  if (truncate) {
    const wrapperClassName = className ? `${truncatedWrapper} ${className}` : truncatedWrapper;
    return (
      <div className={wrapperClassName}>
        <Text asSpan variant={nameVariant}>
          {accountText}
        </Text>{" "}
        <Text asSpan variant={inVariant} className={inClassName}>
          in
        </Text>{" "}
        <Text asSpan variant={nameVariant}>
          {entityText}
        </Text>
      </div>
    );
  }

  return (
    <Flex flexDirection="row" alignItems="center" gap={Sizes.XS} className={className}>
      <Text variant={nameVariant}>{accountText}</Text>
      <Text variant={inVariant} className={inClassName}>
        in
      </Text>
      <Text variant={nameVariant}>{entityText}</Text>
    </Flex>
  );
};
